/**
 * Removes price/MRP rows from HTML tables inside the product description (admin RTE),
 * and re-runs when the tabs section is re-rendered in the theme editor.
 */
(function () {
  function normalizeLabel(cell) {
    if (!cell) return '';
    return cell.innerText.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function shouldRemovePriceRow(tr) {
    var first = tr.querySelector('th, td');
    var lab = normalizeLabel(first);
    return (
      lab === 'price' ||
      lab.startsWith('price ') ||
      lab === 'mrp' ||
      lab === 'our price' ||
      lab === 'selling price' ||
      lab === 'unit price' ||
      lab === 'cost'
    );
  }

  function cleanDescriptionTables(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var tables = root.querySelectorAll(
      '.hdt-product-tab .hdt-tab-item.hdt-rte table, .hdt-product-tab .hdt-product-accordion__content.hdt-rte table, .hdt-type-list .hdt-product-tab__item-content.hdt-rte table'
    );
    tables.forEach(function (table) {
      if (table.classList.contains('hdt-pr_attrs')) return;
      table.querySelectorAll('tr').forEach(function (tr) {
        if (shouldRemovePriceRow(tr)) tr.remove();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    cleanDescriptionTables(document);
  });
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector) cleanDescriptionTables(ev.target);
  });
})();
